<template>
  <div class="main">
    <div class="title-bar">
      <h1>Request a New Password</h1>
    </div>
    <div class="container py-3">
      <FormWrapper method="POST" :action="route('password.email')">
        <transition name="fade">
          <Alert v-if="hasAlert" :alert="alert" class="text-center" />
        </transition>
        <div class="row">
          <div class="col-12 mb-3">
            <Field
              type="text"
              name="email"
              label="Enter the email address you use to log into your account"
            />
          </div>
          <div class="col-12 text-center">
            <button type="submit" class="btn btn-primary">Send Password Reset Link</button>
          </div>
        </div>
      </FormWrapper>
    </div>
  </div>
</template>

<script>
import DisplaysAlerts from "mixins/DisplaysAlerts";
export default {
  mixins: [DisplaysAlerts]
};
</script>

<style lang="scss" scoped>
.container {
  max-width: 576px;
}
</style>